import React, { useEffect, useRef, useState } from 'react';
import { IBwjAnnouncementBannerProps } from './props';
import { Dialog, DialogFooter, DialogType, FontIcon, FontSizes, getTheme, MessageBarType } from '@fluentui/react';
import { BwjButton, BwjButtonType } from '../bwj-button';
import { getBwjAnnouncementBannerColorScheme } from './color';
import $ from 'jquery';

export const PRIVATE_ANNOUNCEMENT_DIALOG: React.FunctionComponent<IBwjAnnouncementBannerProps> = (props) => {
  const { invokeShowAnnouncement: dialogProps, linkHandler } = props;
  const [showDialog, setShowDialog] = useState(false);
  const messageRef = useRef<HTMLParagraphElement | null>(null);
  const theme = getTheme();
  const color = getBwjAnnouncementBannerColorScheme(dialogProps?.messageType ?? MessageBarType.info);

  // on show dialog invoked
  useEffect(() => {
    if(dialogProps === undefined) { return; }
    setShowDialog(true);
  }, [dialogProps]);

  // on every redraw, wire up link event handlers if needed
  useEffect(() => {
    if(showDialog === false || linkHandler === undefined) { return () => {}; }

    let msg = messageRef.current;
    const cancelToken = window.setTimeout(() => {
      msg = messageRef.current;
      if(msg === null) { return; }

      $(msg).children('a').on('click', (e) => {
        linkHandler($(e.target).attr('href') ?? '#');
        e.stopPropagation();
        e.preventDefault();
      });
    }, 50);

    return () => {
      window.clearTimeout(cancelToken);
      if(!!msg) {
        $(msg).children('a').off('click');
      }
    };
  }, [showDialog, linkHandler]);

  const onDismiss = () => setShowDialog(false);

  return (
    <>
      {!!dialogProps &&
      <Dialog
        hidden={showDialog === false}
        onDismiss={onDismiss}
        dialogContentProps={{ type: DialogType.normal }}
        modalProps={{
          isBlocking: false,
          styles: {
            main: {
              width: '100%',
              maxWidth: 500,
            },
            scrollableContent: {
              fontSize: theme.fonts.medium.fontSize,
              '& > div': {
                borderTop: `0.5em solid ${color.main}`,
                backgroundColor: color.background,
              },
              '& .ms-Dialog-header': {
                display: 'none',
              },
              '& .ms-Dialog-inner': {
                padding: '1.5em',
              },
            },
          }
        }}
      >
        {!!dialogProps.icon &&
        <FontIcon
          iconName={dialogProps.icon}
          style={{
            fontSize: FontSizes.superLarge,
            color: color.main,
          }}
        />}
        <p
          ref={messageRef}
          dangerouslySetInnerHTML={dialogProps.renderAsHtml === true ? { __html: dialogProps.message } : undefined}
        >
          {dialogProps.renderAsHtml !== true ? dialogProps.message : null}
        </p>
        <DialogFooter
        styles={{
          actions: {
            fontSize: 16,
            marginTop: '2em',
          }
        }}
        >
          <BwjButton
            buttonStyle={BwjButtonType.DefaultStandard}
            text={props.closeDialogButtonText ?? 'Close'}
            onClick={onDismiss}
          />
        </DialogFooter>
      </Dialog>}
    </>
  );
};
